import { render, staticRenderFns } from "./CollectAdvance.vue?vue&type=template&id=c690783e&scoped=true"
import script from "./CollectAdvance.vue?vue&type=script&lang=js"
export * from "./CollectAdvance.vue?vue&type=script&lang=js"
import style0 from "./CollectAdvance.vue?vue&type=style&index=0&id=c690783e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c690783e",
  null
  
)

export default component.exports